export const logInvariant = (error: Error): void => {
  console.error(error);
  if (typeof window !== 'undefined' && window.__RICOS_LOG_INVARIANT__) {
    window.__RICOS_LOG_INVARIANT__(error);
  }
};

declare global {
  interface Window {
    __RICOS_LOG_INVARIANT__?: (error: Error) => void;
  }
}
